module.exports = __webpack_public_path__ + "static/media/object.6affd655.gif";